/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList, ResourceContextProvider
} from 'react-admin';
import {
    useMediaQuery, makeStyles, FormControl, Select, MenuItem, InputLabel, Paper, Typography, TextField as MuiTextField
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import notify from './components/CustomUseNotify';
import config from "./config.json";
import { saveTokens } from './utils/saveTokens';
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import { stringify } from 'query-string';
import Skeleton from '@material-ui/lab/Skeleton';
// import ReactApexChart from 'react-apexcharts';
import CustomSearch from './components/CustomSearch';
import LinearProgress from '@material-ui/core/LinearProgress';
import CustomFilter from './components/CustomFilter';
import ShowTimePeriod from './components/ShowTimePeriod';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/WarningRounded';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    title: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 22,
        color: customTheme.palette.grey[900],
    },
    summaryBoxLabel2: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
});

const FASTAG_LOGS = "FASTAG_LOGS"
const FASTAG_AGGREGATE_DATA_PARKING = "FASTAG_AGGREGATE_DATA_PARKING"
const FASTAG_AGGREGATE_DATA_BANK = "FASTAG_AGGREGATE_DATA_BANK"

const BanksList = {
    "Airtel": "AIRTEL_BANK",
    "Yes Bank": "YES_BANK",
    "IDFC": "IDFC_BANK"
}

export const FASTagServers = props => {
    const location = useLocation();
    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [currentTab, setCurrentTab] = React.useState(FASTAG_LOGS)
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [prevSearch] = useState(sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : "")
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [showLast10Mins, setShowLast10Mins] = useState(true);

    const dateTimePickerRef = useRef();

    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    let filterTypesInitState = [
        {
            filterType: "Banks",
            dataList: [{ name: "Airtel", id: 1 }, { name: "IDFC", id: 2 }, { name: "Yes Bank", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        }
    ]
    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const filter = { ...settingFilterFormat, start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined, group_by: currentTab === FASTAG_AGGREGATE_DATA_PARKING ? "parking_info_id" : currentTab === FASTAG_AGGREGATE_DATA_BANK ? "bank_name" : undefined };
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));


    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
    };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const FASTagLogs = (props) => {
        return (
            <ResourceContextProvider value="getFastagTimeoutLogs">
                <List
                    {...props}
                    basePath="/getFastagTimeoutLogs"
                    title="FASTag Timeout Logs"
                    bulkActionButtons={false}
                    exporter={false}
                    filter={filter}
                    empty={false}
                    pagination={<CustomPagination />}
                    actions={false}
                    sort={{ field: 'timestamp', order: 'DESC' }}
                    syncWithLocation={false}
                >
                    {
                        isSmallDevice ?
                            <SimpleList
                                primaryText={record => renderTime(record["timestamp"])}
                                secondaryText={record => (<div>
                                    {record.bank_name && <div><span style={{ color: "#5a5a5a" }}>Bank: </span>{record.bank_name}</div>}
                                    {record.transaction_id && <div><span style={{ color: "#5a5a5a" }}>Transaction ID: </span>{record.transaction_id}</div>}
                                    {record.message_id && <div><span style={{ color: "#5a5a5a" }}>Message ID: </span>{record.message_id}</div>}
                                    {record.device_id && <div><span style={{ color: "#5a5a5a" }}>Device ID: </span>{record.device_id}</div>}
                                    {record.gate_id && <div><span style={{ color: "#5a5a5a" }}>Gate ID: </span>{record.gate_id}</div>}
                                    {record.request_type && <div><span style={{ color: "#5a5a5a" }}>Request Type: </span>{record.request_type}</div>}
                                    {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                                </div>)}
                                onContextMenu={event => event.preventDefault()}
                                linkType={false}
                                rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                            />
                            :
                            <Datagrid component={ScrollableTable}>
                                <FunctionField source="bank_name" label="Bank" render={record => record.bank_name ? record.bank_name : '-'} />
                                <FunctionField source="transaction_id" label="Transaction ID" render={record => record.transaction_id ? record.transaction_id : '-'} />
                                <FunctionField source="message_id" label="Message ID" render={record => record.message_id ? record.message_id : '-'} />
                                <FunctionField source="device_id" label="Device ID" render={record => record.device_id ? record.device_id : '-'} />
                                <FunctionField source="gate_id" label="Gate ID" render={record => record.gate_id ? record.gate_id : '-'} />
                                <FunctionField source="timestamp" label="Timestamp" render={record => record["timestamp"] ? renderTime(record["timestamp"]) : '-'} />
                                <TextField source='parking_name' label="Parking Name" />
                                <FunctionField source="request_type" label="Request Type" render={record => record.request_type ? record.request_type : '-'} />
                            </Datagrid>
                    }
                </List>

            </ResourceContextProvider>
        )
    }

    const FASTagAggregateDataByParking = (props) => {
        return (
            <ResourceContextProvider value="getAggregateFastagTimeoutLogs">
                <List
                    {...props}
                    basePath="/getAggregateFastagTimeoutLogs"
                    title="FASTag Aggregate Data"
                    bulkActionButtons={false}
                    exporter={false}
                    filter={filter}
                    empty={false}
                    pagination={<CustomPagination />}
                    actions={false}
                    syncWithLocation={false}
                >
                    {
                        isSmallDevice ?
                            <SimpleList
                                secondaryText={record => (<div>
                                    {record.count && <div><span style={{ color: "#5a5a5a" }}>Timeout Count: </span>{record.count}</div>}
                                    {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                                </div>)}
                                onContextMenu={event => event.preventDefault()}
                                linkType={false}
                                rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                            />
                            :
                            <Datagrid component={ScrollableTable}>
                                <FunctionField source="parking_name" label="Parking Name" render={record => record.parking_name ? record.parking_name : '-'} />
                                <FunctionField source="count" label="Timeout Ratio" render={record => {
                                    let timeoutCount = record.count ? record.count : 0;
                                    let successCount = record.success_count ? record.success_count : 0;
                                    let divisibleNum = timeoutCount + successCount;
                                    return `${record.count != null ? record.count : '-'}/${divisibleNum != null ? divisibleNum : '-'}`;
                                }} />
                                <FunctionField source="count" label="Timeout Percentage" render={record => {
                                    const timeoutCount = record.count ? record.count : 0;
                                    const successCount = record.success_count ? record.success_count : 0;
                                    const divisibleNum = timeoutCount + successCount;
                                    const percentage = divisibleNum ? Math.round((record.count ? record.count : 0)*100/divisibleNum) : 100;
                                    let icon = null, color;
                                    if (percentage >= 50) {
                                        icon = <ErrorIcon style={{ fontSize: 18 }} />;
                                        color = "#f7685b";
                                    } else if (percentage >= 10) {
                                        icon = <WarningIcon style={{ fontSize: 18 }} />;
                                        color = "#e99100";
                                    }
                                    return (
                                        <div style={{display: "flex", alignItems: "center", gap: "8px", color: color }}>
                                            {percentage}%
                                            {icon}
                                        </div>
                                    );
                                }} />
                            </Datagrid>
                    }
                </List>

            </ResourceContextProvider>
        )
    }

    const FASTagAggregateDataByBank = (props) => {
        return (
            <ResourceContextProvider value="getAggregateFastagTimeoutLogs">
                <List
                    {...props}
                    basePath="/getAggregateFastagTimeoutLogs"
                    title="FASTag Aggregate Data"
                    bulkActionButtons={false}
                    exporter={false}
                    filter={filter}
                    empty={false}
                    pagination={<CustomPagination />}
                    actions={false}
                    syncWithLocation={false}
                >
                    {
                        isSmallDevice ?
                            <SimpleList
                                secondaryText={record => (<div>
                                    {record.count && <div><span style={{ color: "#5a5a5a" }}>Timeout Count: </span>{record.count}</div>}
                                    {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                                </div>)}
                                onContextMenu={event => event.preventDefault()}
                                linkType={false}
                                rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                            />
                            :
                            <Datagrid component={ScrollableTable}>
                                <FunctionField source="bank_name" label="Bank" render={record => record.bank_name ? record.bank_name : '-'} />
                                <FunctionField source="count" label="Total Timeout Count" render={record => record.count ? record.count : '-'} />
                            </Datagrid>
                    }
                </List>

            </ResourceContextProvider>
        )
    };

    console.log("dateTimePickerRef:", dateTimePickerRef);

    const handleTabChange = (newTab) => {
        dateTimePickerRef.current?.refreshTime();
        setCurrentTab(newTab);
    }

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Banks") {
                    values = { ...values, bank_name: filterListValue[val].value && BanksList[filterListValue[val].value] ? BanksList[filterListValue[val].value] : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]);

    return <div className={classes.list}>

        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={location.pathname}
            />

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>

        <div className='customStyleForDataSearchDiv' style={{ justifyContent: "flex-end" }}>
            <CustomDateTimePicker ref={dateTimePickerRef} startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} showLast10Mins={showLast10Mins} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
        </div>

        <div style={{ display: "flex", alignItems: "center", columnGap: 10, marginTop: 10, marginBottom: 10, fontSize: 13, boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)' }}>
            <div onClick={() => handleTabChange(FASTAG_LOGS)} style={{ borderBottom: currentTab === FASTAG_LOGS ? "solid 2px #334d6e" : "#FFF", color: currentTab === FASTAG_LOGS ? "#334d6e" : "#999", padding: "12px 25px", cursor: 'pointer', fontWeight: currentTab === FASTAG_LOGS ? 'bold' : 'normal' }}>
                Timeout Logs
            </div>
            <div onClick={() => handleTabChange(FASTAG_AGGREGATE_DATA_PARKING)} style={{ borderBottom: currentTab === FASTAG_AGGREGATE_DATA_PARKING ? "solid 2px #334d6e" : "#FFF", color: currentTab === FASTAG_AGGREGATE_DATA_PARKING ? "#334d6e" : "#999", padding: "12px 25px", cursor: 'pointer', fontWeight: currentTab === FASTAG_AGGREGATE_DATA_PARKING ? 'bold' : 'normal' }}>
                Aggregate Data By Parking
            </div>
            <div onClick={() => handleTabChange(FASTAG_AGGREGATE_DATA_BANK)} style={{ borderBottom: currentTab === FASTAG_AGGREGATE_DATA_BANK ? "solid 2px #334d6e" : "#FFF", color: currentTab === FASTAG_AGGREGATE_DATA_BANK ? "#334d6e" : "#999", padding: "12px 25px", cursor: 'pointer', fontWeight: currentTab === FASTAG_AGGREGATE_DATA_BANK ? 'bold' : 'normal' }}>
                Aggregate Data By Bank
            </div>
        </div>

        {currentTab === FASTAG_LOGS && <FASTagLogs />}
        {currentTab === FASTAG_AGGREGATE_DATA_PARKING && <FASTagAggregateDataByParking />}
        {currentTab === FASTAG_AGGREGATE_DATA_BANK && <FASTagAggregateDataByBank />}

        {/* <List
            {...props}
            title="Fastag Servers"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            pagination={<CustomPagination />}
            actions={false}
            sort={{ field: 'timestamp', order: 'DESC' }}
            syncWithLocation={false}
            style={{ marginTop: 10 }}
        >
            {
                isSmallDevice ?
                    <SimpleList
                        primaryText={record => renderTime(record["timestamp"])}
                        secondaryText={record => (<div>
                            {record.bank_name && <div><span style={{ color: "#5a5a5a" }}>Bank: </span>{record.bank_name}</div>}
                            {record.device_id && <div><span style={{ color: "#5a5a5a" }}>Device ID: </span>{record.device_id}</div>}
                            {record.gate_id && <div><span style={{ color: "#5a5a5a" }}>Gate ID: </span>{record.gate_id}</div>}
                            {record.request_type && <div><span style={{ color: "#5a5a5a" }}>Request Type: </span>{record.request_type}</div>}
                            {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        <FunctionField source="bank_name" label="Bank" render={record => record.bank_name ? record.bank_name : '-'} />
                        <FunctionField source="device_id" label="Device ID" render={record => record.device_id ? record.device_id : '-'} />
                        <FunctionField source="gate_id" label="Gate ID" render={record => record.gate_id ? record.gate_id : '-'} />
                        <FunctionField source="timestamp" label="Timestamp" render={record => record["timestamp"] ? renderTime(record["timestamp"]) : '-'} />
                        <TextField source='parking_name' label="Parking Name" />
                        <FunctionField source="request_type" label="Request Type" render={record => record.request_type ? record.request_type : '-'} />
                    </Datagrid>
            }
        </List> */}
    </div>
};
